import { useEffect, useState } from "react";

import { createCompany, createCompanyAdministrator, listCompanies } from "../services/api";

const emptyCompany = { name: "", slug: "" };
const emptyAdministrator = { tenant_id: "", full_name: "", email: "", temporary_password: "" };

export function CompanyManagementPage() {
  const [companies, setCompanies] = useState([]);
  const [company, setCompany] = useState(emptyCompany);
  const [administrator, setAdministrator] = useState(emptyAdministrator);
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");

  async function load() {
    try {
      const result = await listCompanies();
      setCompanies(result.items ?? []);
    } catch (requestError) {
      setError(requestError.message === "platform_admin_required" ? "Somente a WellTech pode administrar empresas." : "Não foi possível carregar as empresas.");
    }
  }

  useEffect(() => { load(); }, []);

  function changeCompanyName(value) {
    const slug = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
    setCompany({ name: value, slug });
  }

  async function submitCompany(event) {
    event.preventDefault(); setBusy(true); setError(""); setNotice("");
    try {
      const created = await createCompany(company);
      setCompany(emptyCompany);
      setAdministrator({ ...emptyAdministrator, tenant_id: created.id });
      setNotice(`Empresa ${created.name} cadastrada. Defina agora o administrador responsável.`);
      await load();
    } catch (requestError) {
      setError(requestError.message === "tenant_slug_exists" ? "Já existe uma empresa com esse identificador." : "Não foi possível cadastrar a empresa.");
    } finally { setBusy(false); }
  }

  async function submitAdministrator(event) {
    event.preventDefault(); setBusy(true); setError(""); setNotice("");
    try {
      await createCompanyAdministrator(administrator.tenant_id, {
        full_name: administrator.full_name,
        email: administrator.email,
        temporary_password: administrator.temporary_password
      });
      setAdministrator(emptyAdministrator);
      setNotice("Administrador vinculado. A empresa já pode cadastrar usuários e definir permissões.");
      await load();
    } catch (requestError) {
      setError(requestError.message === "tenant_administrator_exists" ? "Esta empresa já possui administrador." : "Não foi possível vincular o administrador.");
    } finally { setBusy(false); }
  }

  return <section className="company-admin">
    <header className="page-heading"><div><span className="eyebrow">Administração WellTech</span><h1>Empresas e administradores</h1><p>Cadastre primeiro a empresa. Depois vincule o responsável que administrará usuários, permissões e solicitações.</p></div></header>
    <ol className="onboarding-steps" aria-label="Sequência de implantação"><li className="active"><strong>1</strong><span>Empresa</span></li><li><strong>2</strong><span>Administrador</span></li><li><strong>3</strong><span>Usuários e permissões</span></li><li><strong>4</strong><span>Solicitações</span></li></ol>
    {notice ? <p className="login-success" role="status">{notice}</p> : null}{error ? <p className="login-error" role="alert">{error}</p> : null}
    <div className="company-admin-grid">
      <form className="access-card" onSubmit={submitCompany}><span className="eyebrow">Etapa 1</span><h2>Cadastrar empresa</h2><label>Razão social ou nome<input value={company.name} onChange={(event) => changeCompanyName(event.target.value)} required /></label><label>Identificador de acesso<input value={company.slug} onChange={(event) => setCompany({ ...company, slug: event.target.value.toLowerCase() })} pattern="[a-z0-9]+(?:-[a-z0-9]+)*" required /><small>Será usado no campo Empresa do login.</small></label><button className="primary" disabled={busy}>Cadastrar empresa</button></form>
      <form className="access-card" onSubmit={submitAdministrator}><span className="eyebrow">Etapa 2</span><h2>Definir administrador</h2><label>Empresa<select value={administrator.tenant_id} onChange={(event) => setAdministrator({ ...administrator, tenant_id: event.target.value })} required><option value="">Selecione</option>{companies.filter((item) => !item.administrator).map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}</select></label><label>Nome completo<input value={administrator.full_name} onChange={(event) => setAdministrator({ ...administrator, full_name: event.target.value })} required /></label><label>E-mail de login<input type="email" value={administrator.email} onChange={(event) => setAdministrator({ ...administrator, email: event.target.value })} required /></label><label>Senha provisória<input type="password" minLength="10" value={administrator.temporary_password} onChange={(event) => setAdministrator({ ...administrator, temporary_password: event.target.value })} required /><small>Mínimo de 10 caracteres. MFA será configurado no primeiro acesso.</small></label><button className="primary" disabled={busy || !administrator.tenant_id}>Vincular administrador</button></form>
    </div>
    <section className="company-list"><h2>Empresas cadastradas</h2>{companies.map((item) => <article key={item.id}><div><strong>{item.name}</strong><span>{item.slug} · {item.user_count} usuário(s)</span></div><div>{item.administrator ? <><strong>{item.administrator.full_name}</strong><span>{item.administrator.email}</span></> : <span className="pending-admin">Administrador pendente</span>}</div></article>)}</section>
  </section>;
}
